import { SCREENERS } from "../actionTypes";
import { SCREENERS_TABS } from '../../utils/global_variables';
const initialState = {
    allScreenersDetails: [],
    bIsGridDataShow: false,
    arrCategoryOptions: [],
    arrActiveScannerData: [],
    arrFavouritesScreeners: [],
    objselectedScreener: {},
    selectedTab: SCREENERS_TABS.STRATERGY,
    arrScreenersGridData: [],
    strSeletedCategory: '',
    arrIndexSectorList: [],
    lastScannerData: null,
    arrPremiumDiscount: [],
    arrNearBookValue: [],
    FIIArray: [],
    DIIArray: [],
    MFArray: [],
    mergerAndAcqData: [],
    bulkData: [],
    blockData: []
};

const screenersReducer = (state = initialState, actions) => {

    switch (actions.type) {

        //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
        case SCREENERS?.GET_BULK_SUCCESS: {
            return {
                ...state,
                bulkData: actions?.payload
            };
        }

        case SCREENERS?.GET_BLOCK_SUCCESS: {
            return {
                ...state,
                blockData: actions?.payload
            };
        }

        case SCREENERS?.GET_MERGER_ACQ_SUCCESS: {
            return {
                ...state,
                mergerAndAcqData: actions?.payload
            };
        }

        case SCREENERS?.GET_DII_SUCCESS: {
            return {
                ...state,
                DIIArray: actions?.payload
            };
        }

        case SCREENERS?.GET_FII_SUCCESS: {
            return {
                ...state,
                FIIArray: actions?.payload
            };
        }

        case SCREENERS?.GET_MF_SUCCESS: {
            return {
                ...state,
                MFArray: actions?.payload
            };
        }
        //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End
        case SCREENERS.GET_APP_WAVE_SCREENERS_DETAILS_SUCCESS: {
            return {
                ...state,
                allScreenersDetails: actions.payload
            };
        }
        case SCREENERS.GET_APP_WAVE_SCREENERS_DETAILS_FAILURE: {
            return {
                ...state,
                allScreenersDetails: actions.payload
            };
        }
        case SCREENERS.SET_IS_GRID_DATA_SHOW: {
            return {
                ...state,
                bIsGridDataShow: actions.payload
            };
        }
        case SCREENERS.SET_CATEGORY_OPTIONS: {
            return {
                ...state,
                arrCategoryOptions: actions.payload
            };
        }
        case SCREENERS.SET_ACTIVE_SCANNERS_DATA: {
            return {
                ...state,
                arrActiveScannerData: actions.payload
            };
        }
        case SCREENERS.SET_FAVOURITE_SCREENERS: {
            return {
                ...state,
                arrFavouritesScreeners: actions.payload
            };
        }
        case SCREENERS.SET_SELECTED_SCREENER: {
            return {
                ...state,
                objselectedScreener: actions.payload
            };
        }
        case SCREENERS.SET_SELECTED_TAB: {
            return {
                ...state,
                selectedTab: actions.payload
            };
        }
        case SCREENERS.GET_PREV_SCANNER: {
            return {
                ...state,
                lastScannerData: actions.payload
            };
        }
        case SCREENERS.GET_SCREENERS_GRID_DATA_SUCCESS: {
            return {
                ...state,
                arrScreenersGridData: actions.payload
            };
        }
        case SCREENERS.GET_SCREENERS_GRID_DATA_FAILURE: {
            return {
                ...state,
                arrScreenersGridData: actions.payload
            };
        }
        case SCREENERS.SET_SELECTED_CATEGORY: {
            return {
                ...state,
                strSeletedCategory: actions.payload
            };
        }
        case SCREENERS.GET_INDEX_SECTOR_LIST_SUCCESS: {
            return {
                ...state,
                arrIndexSectorList: actions.payload
            };
        }
        case SCREENERS.GET_INDEX_SECTOR_LIST_FAILURE: {
            return {
                ...state,
                arrIndexSectorList: actions.payload
            };
        }
        case SCREENERS.GET_NEAR_BOOK_VALUE_DETAILS_SUCCESS: {
            return {
                ...state,
                arrNearBookValue: actions.payload
            };
        }
        case SCREENERS.GET_PREMIUM_DISCOUNT_DETAILS_SUCCESS: {
            return {
                ...state,
                arrPremiumDiscount: actions.payload
            };
        }
        default:
            return state;
    }

};

export default screenersReducer;